import React, { useReducer, useContext, useState, useEffect } from 'react';
import PatientInfo from './PatientInfo';
import Breadcrumb from '../../shared/Breadcrumb';
import Util from '../../../Util';
import axios from 'axios';
import { AuthContext } from '../../../contexts/AuthContext';
import { apiRoutes } from '../../../AppSettings';
import alertify from "alertifyjs";
import { Link, useHistory } from 'react-router-dom';

const UPDATE_APPOINMENT = "UPDATE_APPOINMENT";

const initialValue = {
	date: (new Date()).getDate() + '/' + ((new Date()).getMonth() + 1) + '/' + (new Date()).getFullYear(),
    selectedAppoinmentId: 0,
    description: '',
    uploadedFileName: '',
    uploadedFileBase64: ''
}

const AddMedicalRecord = (props) => {
    const doctor = JSON.parse(props.location.state.doctor);
	const patient = JSON.parse(props.location.state.patient);
	const appoinments = JSON.parse(props.location.state.appoinments);

    const { userState } = useContext(AuthContext);
    const [medicalRecord, setMedicalRecord] = useState(initialValue);
    const history = useHistory();

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };
    

    useEffect(() => {
        if(appoinments.length == 1)
		{
			setMedicalRecord({...medicalRecord, selectedAppoinmentId: appoinments[0].appoinmentId});
		}
    }, []);

    const handleSubmit = () => {
        console.log(medicalRecord);
	    if(medicalRecord.selectedAppoinmentId == 0)
		{
            console.log('please select appoinment')
            alertify.error("please select appoinment");
            return;
        }
     
        medicalRecord.date = medicalRecord.date.split('/')[1] +'/'+medicalRecord.date.split('/')[0]+'/'+ medicalRecord.date.split('/')[2];
        
     	axios.post(apiRoutes.addMedicalRecord, JSON.stringify(medicalRecord), options)
        .then((response) => {
            if(response.status === 200)
            {
                console.log(response.data);
                alertify.success("Medical record added successfully");

                history.push({
                    pathname:'/PatientProfile',
                    state: {
                        patientId: patient.patientId
                    }
                })
            }
        }, (error) => {
            console.log(error);
        });
    }

    
    const getFiles = (e) => {
        medicalRecord.uploadedFileName =  e.target.files[0].name;

        var reader = new FileReader();
        reader.onload = function(upload) {
            console.log(upload);
            setMedicalRecord({...medicalRecord, uploadedFileBase64: upload.target.result});
        };
        reader.readAsDataURL(e.target.files[0]);
    }

    return (  
        <div>
            <Breadcrumb title="Add Billing" />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <PatientInfo patient={patient}></PatientInfo>
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title mb-0">Add Medical Records</h4>
                                </div>
                                <div className="card-body">
                                <form onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="biller-info">
                                                    <h4 className="d-block">Dr. {doctor.firstName} {doctor.lastName}</h4>
                                                    <span className="d-block text-sm text-muted">{doctor.category}</span>
                                                    <span className="d-block text-sm text-muted">{doctor.state}, {doctor.country}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 text-sm-right">
                                                <div className="billing-info">
                                                    <h4 className="d-block">{Util.getFormatDate({date: (new Date())})}</h4>
                                                    <span className="d-block text-muted"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card card-table">
                                            <div className="card-body">
                                                <div className="modal-body">
                                                    <div className="form-group">
                                                        <label>Appoinment</label>
                                                        {
    														appoinments.length > 1 ?  <select className="select form-control" value={medicalRecord.selectedAppoinmentId} 
                                                                                        onChange={(e) => setMedicalRecord({...medicalRecord, selectedAppoinmentId: e.target.value})}
                                                                                        >
                                                                                            <option></option>
                                                                                            {
                                                                                                appoinments.map(item => (
                                                                                                    <option key={item.appoinmentId} value={item.appoinmentId}>{item.appoinmentNumber}</option>
                                                                                                ))
                                                                                            }
                                                                                        </select>
																				: 
																				<div> <strong>{appoinments[0].appoinmentNumber}</strong></div>
																					
	    												}
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Date</label>
                                                        <input type="text" className="form-control datepicker" required value={medicalRecord.date}
                                                        onChange = {(e) => setMedicalRecord({...medicalRecord, date: e.target.value})}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Description ( Optional )</label>
                                                        <textarea className="form-control"  value={medicalRecord.description}
                                                        onChange = {(e) => setMedicalRecord({...medicalRecord, description: e.target.value})}
                                                        ></textarea>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Upload File</label> 
                                                        <input type="file" className="form-control" 
                                                        onChange={getFiles}
                                                        required/>
                                                    </div>	
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 text-right">
                                                <div className="signature-wrap">
                                                    <div className="signature">
                                                        {doctor.firstName} {doctor.lastName}
                                                    </div>
                                                    <div className="sign-name">
                                                        <p className="mb-0">( Dr. {doctor.firstName} {doctor.lastName} )</p>
                                                        <span className="text-muted">Signature</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="submit-section">
                                                    <button type="submit" className="btn btn-primary submit-btn">Save</button>
                                                    <Link className="btn btn-secondary submit-btn" 
                                                        to={
                                                            {
                                                                pathname:'/PatientProfile',
                                                                state: {
                                                                    patientId: patient.patientId
                                                                }
                                                            }
                                                    }>Cancel</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>		
        </div>
    );
}
 
export default AddMedicalRecord;
